import React, { Fragment } from "react";
import { Image, Col } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { SocialIcon } from "react-social-icons";

import CustomizedTimeline from "./CustomizedTimeline";
const images = require.context("../../public/static/images", true);

const renderCodementorBadge = () => {
  return (
    <div>
      <a href="https://www.codementor.io/@okypris?refer=badge">
        <img
          src="https://www.codementor.io/m-badges/okypris/im-a-cm-b.svg"
          alt="Codementor badge"
        />
      </a>
    </div>
  );
};

function Home() {
  return (
    <Container className="pt-1 pb-5 px-4 ">
      <Row style={{ display: "flex", justifyContent: "space-between" }}>
        <Col xs={12} sm={4} md={3} className="m-auto">
          <Row style={{ justifyContent: "center" }}>
            <Image
              src={images(`./${"orf.jpeg"}`).default}
              // class="center-block"
              roundedCircle
              fluid
              width="50%"
              class="align-content-md-center"
            />
          </Row>
        </Col>

        <Col xs={12} sm={6} md={6}>
          <Row>
            <h1 class="font-weight-light">Home</h1>
            <p>
              Welcome! My name is Orfeas Kypris. An engineer by training, after
              6 years in academic research I joined industry, to develop systems
              for data and predictive analytics. I have experience in sensor
              development, signal processing, machine and deep learning, and a
              solid background in mathematics, physics, and computational
              methods.
            </p>
          </Row>
          <Row style={{ textAlign: "center", justifyContent: "center" }}>
            <Col>{renderCodementorBadge()}</Col>
            <Col>
              <SocialIcon
                url="https://linkedin.com/in/kypris"
                style={{ height: 50, width: 50 }}
              />
            </Col>
            <Col>
              <SocialIcon
                url="https://github.com/orphefs"
                style={{ height: 50, width: 50 }}
              />
            </Col>
            <Col>
              <SocialIcon
                url="https://orphefs.medium.com/"
                style={{ height: 50, width: 50 }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3 class="font-weight-light">Academia</h3>
          <p>
            I previously studied electrical and electronic engineering at{" "}
            <a href="http://www.cardiff.ac.uk">Cardiff University</a>, where I
            also later completed my MSc in Magnetics at the{" "}
            <a href="https://en.wikipedia.org/wiki/Wolfson_Centre_for_Magnetics">
              Wolfson Center for Magnetics Research
            </a>
            . I then moved to the{" "}
            <a href="http://ecpe.iastate.edu">
              Electrical and Computer Engineering at Iowa State University
            </a>
            , where I completed my Ph.D. under the supervision of{" "}
            <a href="https://www.ece.iastate.edu/profiles/david-c-jiles/">
              Prof David C. Jiles
            </a>
            . There I developed a{" "}
            <a href="https://lib.dr.iastate.edu/etd/14373/">novel method</a> for
            the stress profiling of magnetic materials. Moving on with my
            journey, I returned to the UK, where I was a postdoc at the{" "}
            <a href="https://www.cs.ox.ac.uk/research/cyberphysical/">
              Cyber Physical Systems
            </a>{" "}
            Laboratory. There I developed indoor and undeground localization
            technologies based on low-frequency magnetic fields.
          </p>

          <h3 class="font-weight-light">Industry</h3>

          <p>
            After academia, I moved into industry, and joined{" "}
            <a href="https://www.navenio.com">Navenio</a>, where as part of the
            core research team, I developed aspects of the company's indoor
            localization engine. After Navenio, I completed the mandatory army
            conscription in Cyprus, and then I moved back to Greece, where I
            worked for a <a href="https://www.iknowhow.com">iKnowHow</a>, a
            software and robotics integrator. There I was responsible for
            building out AI-powered software to imbue cognition into our custom
            robotic solutions. After my journey at iKnowHow, I became a
            freelancer, developing full-stack data science solutions for
            organizations worldwide (for-profit and NGOs).
          </p>
        </Col>
      </Row>
      <Row>
        <CustomizedTimeline />
      </Row>
    </Container>
  );
}

export default Home;
